import React, { PureComponent} from 'react';
import { Terminal } from 'xterm';
import { WebLinksAddon } from 'xterm-addon-web-links';
import { FitAddon } from 'xterm-addon-fit'; // 根据容器大小展示合适的终端
import { AttachAddon } from 'xterm-addon-attach'; // 连接到服务器通过WebSocket的运行的进程

import 'xterm/css/xterm.css'

class TerminalCom extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
    let url = 'wss://'+ location.hostname +'/ws?mac='+this.props.mac
    console.log("wss url=", url)
    this.socket = new WebSocket(url);

    this.initTerminal()
    // 监听页面resize，实时调整terminal的rows，cols
     window.addEventListener('resize', this.onTerminalResize);
  }

  onTerminalResize = () => {
    const terminalContainer = this.terminalContainerRef.current;
    const width = terminalContainer.parentElement.clientWidth;
    const height = terminalContainer.parentElement.clientHeight;
    const { xterm } = this;
    // 计算cols，rows
    const cols = (width - xterm._core.viewport.scrollBarWidth - 15) / xterm._core._renderService._renderer.dimensions.actualCellWidth;
    const rows = height / xterm._core._renderService._renderer.dimensions.actualCellHeight - 1;
    this.xterm.resize(
      parseInt(cols.toString(), 10),
      parseInt(rows.toString(), 10)
    );
  };

  initTerminal = () => {
    const terminal = new Terminal({
      rendererType: 'canvas', // 渲染类型
      convertEol: true,
      cursorBlink: true, // 光标闪烁
      cursorStyle: 'block', // 光标样式
      rows:40,
      cols:100,
      theme: {
        foreground: "#ECECEC", //字体
        background: "#000000", //背景色
        cursor: "help", //设置光标
        lineHeight: 20
      }
    });
    const webLinksAddon = new WebLinksAddon();
    const fitAddon = new FitAddon();
    const attachAddon = new AttachAddon(this.socket);
    terminal.loadAddon(webLinksAddon);
    terminal.loadAddon(fitAddon);
    terminal.loadAddon(attachAddon);
    terminal.open(document.getElementById('myTerminal'));
    fitAddon.fit();

    // 限制和后端交互，只有输入回车键才显示结果
    terminal.prompt = () => {
      terminal.write('\r\n$ ');
    };
    terminal.prompt();
  };

  render() {
    return (<div ref={this.terminalContainerRef} id="myTerminal" />);
  }
}

export default TerminalCom;




// WEBPACK FOOTER //
// ./src/components/myTerminal.js